module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "sell"
  }, [_c('div', {
    staticClass: "bread"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/fh.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "con"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("首页")]), _vm._v("-")], 1), _vm._v(" "), _c('li', {
    staticClass: "current"
  }, [_vm._v("出售账号")])])]), _vm._v(" "), _c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '活动详情'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con",
    domProps: {
      "innerHTML": _vm._s(_vm.act_info.sell_info)
    }
  })], 1), _vm._v(" "), _c('price-form', {
    ref: "form",
    attrs: {
      "sell_description": _vm.config_info.sell_description,
      "title": '我要出售账号',
      "wechatShow": _vm.act_info.display_weixin_sell,
      "wechat": _vm.act_info.service_sell,
      "qqShow": _vm.act_info.display_qq_sell,
      "qq": _vm.act_info.qq_sell,
      "type": 3,
      "sale_extend": _vm.act_info.sale_extend * 1 || 0
    },
    on: {
      "submit": _vm.submitData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '活动细则'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con",
    domProps: {
      "innerHTML": _vm._s(_vm.act_info.sell_rule)
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58146307"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sell/sell.vue
// module id = 631
// module chunks = 31